import React, { useCallback, useEffect, useState } from 'react';
import { FaCamera, FaCheckCircle, FaExclamationTriangle, FaSpinner, FaUserShield } from 'react-icons/fa';
import { freshnessService } from '../../../../services/freshnessService';

export default function VehicleFreshnessAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const data = await freshnessService.getVehicleAlerts();
      setAlerts(Array.isArray(data) ? data : []);
    } catch {
      setAlerts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <p className="text-xs text-slate-500 flex items-center gap-1">
        <FaSpinner className="animate-spin" /> Checking inventory freshness…
      </p>
    );
  }

  if (!alerts.length) return null;

  return (
    <div className="space-y-3 mb-6">
      {alerts.map((alert) => (
        <div
          key={alert.inventoryVehicleId}
          className="rounded-xl border border-red-200 bg-red-50 p-4 space-y-3"
        >
          <p className="text-sm font-bold text-red-900 flex items-center gap-2">
            <FaExclamationTriangle /> Vehicle parts paused — failed claims
          </p>
          <p className="text-xs text-red-800">{alert.message}</p>
          <ol className="text-xs text-red-900 space-y-2 list-none">
            <li className="flex items-start gap-2">
              <FaCamera className="mt-0.5 shrink-0" />
              <span>
                <strong>Step 1:</strong> {alert.checklist?.step1 || 'Re-photograph all remaining parts'}
              </span>
            </li>
            <li className="flex items-start gap-2">
              <FaUserShield className="mt-0.5 shrink-0" />
              <span>
                <strong>Step 2:</strong> {alert.checklist?.step2 || 'Submit for admin review'}
              </span>
            </li>
            <li className="flex items-start gap-2">
              <FaCheckCircle className="mt-0.5 shrink-0" />
              <span>
                <strong>Step 3:</strong> {alert.checklist?.step3 || 'Admin signs off → parts resume'}
              </span>
            </li>
          </ol>
          <p className="text-[10px] text-red-700 italic">
            Mark-sold is available for convenience but does not replace re-activation after claim pauses.
          </p>
        </div>
      ))}
    </div>
  );
}
